import {createReducer} from 'redux-act';
import {
  CREATE_PRICE_ADJUSTMENT,
  CREATE_PRICE_ADJUSTMENT_SUCCESS,
  DELETE_PRICE_ADJUSTMENT,
  DELETE_PRICE_ADJUSTMENT_SUCCESS,
  RESET_ALL_PRICE_ADJUSTMENTS,
  RESET_ALL_PRICE_ADJUSTMENTS_SUCCESS,
  OPEN_PRICE_ADJUSTMENT_MODAL,
  CLOSE_PRICE_ADJUSTMENT_MODAL,
  SET_PRICE_ADJUSTMENT_FORM_DATA,
  RESET_PRICE_ADJUSTMENT_FORM,
  GET_ALL_PRICE_ADJUSTMENTS_SUCCESS,
  SET_LOADING
} from './action';

const initialState = {
  adjustments: [],
  isLoading: false,
  error: null,
  isModalOpen: false,
  formData: {
    direction: 'increase',
    platform: '',
    hybridModeEnabled: false,
    scope: 'items',
    type: 'percentage',
    value: ''
  },
  hasUnsavedChanges: false,
  allPriceAdjustments: []
};

const platformPriceAdjustmentsReducer = createReducer(
  {
    [GET_ALL_PRICE_ADJUSTMENTS_SUCCESS]: (state, payload) => ({
      ...state,
      allPriceAdjustments: payload || []
    }),
    [CREATE_PRICE_ADJUSTMENT]: (state) => ({
      ...state,
      isLoading: true,
      error: null
    }),
    [CREATE_PRICE_ADJUSTMENT_SUCCESS]: (state, payload) => ({
      ...state,
      isLoading: false,
      allPriceAdjustments: [...state.allPriceAdjustments, payload],
      error: null,
      isModalOpen: false,
      hasUnsavedChanges: false
    }),
    [DELETE_PRICE_ADJUSTMENT]: (state) => ({
      ...state,
      isLoading: true,
      error: null
    }),
    [DELETE_PRICE_ADJUSTMENT_SUCCESS]: (state, payload) => ({
      ...state,
      isLoading: false,
      allPriceAdjustments: state.allPriceAdjustments?.filter(
        (adj) => adj._id !== payload
      ),
      error: null
    }),
    [RESET_ALL_PRICE_ADJUSTMENTS]: (state) => ({
      ...state,
      isLoading: true,
      error: null
    }),
    [RESET_ALL_PRICE_ADJUSTMENTS_SUCCESS]: (state) => ({
      ...state,
      isLoading: false,
      allPriceAdjustments: [],
      error: null
    }),
    [OPEN_PRICE_ADJUSTMENT_MODAL]: (state) => ({
      ...state,
      isModalOpen: true
    }),
    [CLOSE_PRICE_ADJUSTMENT_MODAL]: (state) => ({
      ...state,
      isModalOpen: false,
      hasUnsavedChanges: false,
      formData: initialState.formData
    }),
    [SET_PRICE_ADJUSTMENT_FORM_DATA]: (state, payload) => ({
      ...state,
      formData: {
        ...state.formData,
        ...payload
      },
      hasUnsavedChanges: true
    }),
    [RESET_PRICE_ADJUSTMENT_FORM]: (state) => ({
      ...state,
      formData: initialState.formData,
      hasUnsavedChanges: false
    }),
    [SET_LOADING]: (state, payload) => ({
      ...state,
      isLoading: payload
    })
  },
  initialState
);

export default platformPriceAdjustmentsReducer;
